import type { RootState } from 'features/app/store/store';

export const getMachinePreferencesSelector = ({
  machinePreferences,
}: RootState) => machinePreferences ?? {};

export const getIsMachinePreferencesProvidedSelector = ({
  machinePreferences,
}: RootState) => {
  const { machineId, stationNumber } = machinePreferences ?? {};

  return Boolean(machineId && stationNumber);
};

export const machineCallCenterCodeSelector = ({
  machinePreferences,
}: RootState) => machinePreferences?.callCenterCode;
